<template>
	<div class="pg-btn-holder">
		<button
			class="btn btn-block btn-default pg-button"
			tabindex="1"
			:id="btnId"
			:disabled="disabled || loading"
			:class="{
				'disabled': disabled || loading,
				'hide': btnHide,
				'maintenance': maintenance
			}"
			@click="handleClicked">

			<div class="hover-desc">
				<h5 class="heading-normal">{{ $t(`wallet.${btnId}`) }}</h5>
				<p>
					{{ $t(`wallet.${btnId}-info`) }}
				</p>
			</div>

			<div class="pg-icon">
				<div v-if="maintenance" class="maintenance">
					<p>
						{{ $t('wallet.underMaintenance') }}
						<span>{{ $t('wallet.tryAgain') }}</span>
					</p>
				</div>
			</div>
			<span v-if="loading" class="spinner-circle"></span>
			<span v-if="!loading" class="pg-label">{{ label }}</span>
		</button>
	</div>
</template>

<script>
export default {
	name: 'pgButton',
	props: {
		btnId: {
			type: String,
			default: ''
		},
		btnHide: {
			type: Boolean,
			default: false
		},
		label: {
			type: String,
			default: ''
		},
		disabled: {
			type: Boolean,
			default: false
		},
		buttonClick: {
			type: Function,
			default: () => {}
		},
		loading: {
			type: Boolean,
			default: false
		},
		pgDetails: {
			type: Object,
			default: null,
			required: true
		},
		maintenance: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		handleClicked() {
			this.$emit('click-pg', this.pgDetails);
		}
	}
};
</script>

<style lang="less" scoped>
	.pg-button {
		height: 80px;
		border: 1px solid #474747;
		background-color: fade(#e6e6e6, 5%);
		padding: 0;
		transition: all .3s;
		position: relative;
		margin-top: 0;
		span {
			display: none;
			font-size: 16px;
			color: #d9d9d9;
			font-weight: normal;
			position: absolute;
			width: 100%;
		}
		.hover-desc {
			display: none;
		}
		.pg-icon {
			width: 100%;
			height: 100%;
			background: url("../../../static/images/pg-list/pg-list.png") no-repeat -228px -560px;
		}
		&#molglobal,
		&#west_molglobal {
			.pg-icon {
				background-position: -228px -840px;
			}
		}
		&#paysafecard {
			.pg-icon {
				background-position: -228px -700px;
			}
		}
		&#boacompra {
			.pg-icon {
				background-position: 0 -840px;
			}
		}
		&#mycard {
			.pg-icon {
				background-position: 0 -700px;
			}
		}
		&#mol_12call {
			.pg-icon {
				background-position: 0 -140px;
			}
		}
		&#mol_truemoney {
			.pg-icon {
				background-position: -228px 0;
			}
		}
		&#truemoney {
			.pg-icon {
				background-position: 0 0;
			}
		}
		&#th_xsolla, &#sea_xsolla {
			.pg-icon {
				background-position: -228px -140px;
			}
			span {
				display: block;
				top: 100px;
			}
		}
		&#west_msol {
			background: none;
		}
		&#ingenico,
		&#xsolla_credit {
			.pg-icon {
				background-position: -228px -140px;
			}
			span {
				display: block;
				top: 100px;
			}
		}
		&#karmakoin {
			.pg-icon {
				background-position: -228px -280px;
			}
		}
		&#paypal {
			.pg-icon {
				background-position: 0 -280px;
			}
		}
		&#xsolla {
			.pg-icon {
				background-position: 0 -420px;
			}
			span {
				display: block;
				top: 85px;
			}
		}
		&#nexoncards {
			.pg-icon {
				background-position: -228px -415px;
			}
		}
		&#epin {
			.pg-icon {
				background-position: 0 -560px;
			}
		}

		&:hover {
			background-color: fade(#e6e6e6, 15%);
		}
		&:focus {
			border: 1px solid fade(#fff, 20%);
			background-color: fade(#000, 50%);
			.pg-icon {
				opacity: .3;
			}
		}
		&.disabled {
			opacity: .3;
			&:hover,
			&:focus {
				border: 1px solid #474747;
				background-color: fade(#e6e6e6, 5%);
			}
			&#th_xsolla,
			&#xsolla,
			&#xsolla_credit,
			&#ingenico {
				span {
					opacity: .5;
				}
			}
			&.maintenance {
				opacity: 1;
			}
		}
		@media (max-width: 600px) {
			width: 100%;
			.pg-icon {
				width: 200px;
				height: 60px;
				margin: 0 auto;
				background-position: -243px -598px;
			}
			&#paysafecard {
				.pg-icon {
					background-position: -245px -740px;
				}
			}
			&#boacompra {
				.pg-icon {
					background-position: -16px -880px;
				}
			}
			&#sea_xsolla {
				.pg-icon {
					background-position: -243px -162px;
				}
			}
			&#mycard {
				.pg-icon {
					background-position: -17px -739px;
				}
			}
			&#molglobal,
			&#west_molglobal {
				.pg-icon {
					background-position: -245px -880px;
				}
			}
			&#mol_12call {
				.pg-icon {
					background-position: -16px -179px;
				}
			}
			&#mol_truemoney {
				.pg-icon {
					background-position: -242px -44px;
				}
			}
			&#truemoney {
				.pg-icon {
					background-position: -13px -39px;
				}
			}
			&#th_xsolla,
			&#ingenico,
			&#xsolla_credit {
				.pg-icon {
					display: none;
				}
				&.maintenance {
					.pg-icon {
						display: block !important;
						background: none;
					}
					.pg-label {
						top: -40px;
					}
				}
				span {
					display: block;
					position: relative;
					top: 3px;
				}
			}
			&#karmakoin {
				.pg-icon {
					background-position: -240px -319px;
				}
			}
			&#paypal {
				.pg-icon {
					background-position: -14px -319px;
				}
			}
			&#xsolla {
				.pg-icon {
					background-position: -15px -448px;
				}
				span {
					display: none;
				}
			}
			&#nexoncards {
				.pg-icon {
					background-position: -241px -455px;
				}
			}
			&#epin {
				.pg-icon {
					background-position: -18px -598px;
				}
			}
			.maintenance {
				position: absolute;
				width: 100%;
				height: 100%;
				left:0;
				top: 0;
				padding: 10px;
				p {
					top:20px !important;
				}
			}
		}
		// added this to support Safari browser and mobile device only
		@media only screen and (min-device-pixel-ratio:2) {
			.pg-icon {
				background-size:110px 60px
			}
		}
		@media only screen
			and (max-device-width: 600px)
			and (min-device-width : 320px) {
			width: 100%;
			display:inline-block;
			.pg-icon {
				width: 200px;
				height: 60px;
				margin: 0 auto;
				background-position: -243px -598px;
			}
			&#paysafecard {
				.pg-icon {
					background-position: -245px -740px;
				}
			}
			&#boacompra {
				.pg-icon {
					background-position: -16px -880px;
				}
			}
			&#molglobal,
			&#west_molglobal {
				.pg-icon {
					background-position: -245px -880px;
				}
			}
			&#sea_xsolla {
				.pg-icon {
					background-position: -243px -162px;
				}
			}
			&#mycard {
				.pg-icon {
					background-position: -17px -739px;
				}
			}
			&#mol_12call {
				.pg-icon {
					background-position: -16px -179px;
				}
			}
			&#mol_truemoney {
				.pg-icon {
					background-position: -242px -44px;
				}
			}
			&#truemoney {
				.pg-icon {
					background-position: -13px -39px;
				}
			}
			&#th_xsolla,
			&#ingenico,
			&#xsolla_credit{
				.pg-icon {
					display: none;
				}
				&.maintenance {
					.pg-icon {
						display: block !important;
						background: none;
					}
					.pg-label {
						top: -40px;
					}
				}
				span {
					display: inline-block;
					position: relative;
					top: 32px;
					height: 100%;
				}
			}
			&#karmakoin {
				.pg-icon {
					background-position: -240px -319px;
				}
			}
			&#paypal {
				.pg-icon {
					background-position: -14px -319px;
				}
			}
			&#xsolla {
				.pg-icon {
					background-position: -15px -448px;
				}
				span {
					display: none;
				}
			}
			&#nexoncards {
				.pg-icon {
					background-position: -241px -455px;
				}
			}
			&#epin {
				.pg-icon {
					background-position: -18px -598px;
				}
			}
			.maintenance {
				position: absolute;
				width: 100%;
				height: 100%;
				left:0;
				top: 0;
				padding: 10px;
				p {
					top:20px !important;
				}
			}
		}
		@media (min-width: 600px) {
			height: 140px;
		}
		@media (min-width: 768px) {

		}
		@media (min-width: 1024px) {
		}
		.maintenance {
			background-color: fade(#000, 80%);
			width: 100%;
			height: 100%;
			p {
				color: #e5e5e5;
				text-transform: uppercase;
				position: absolute;
				top: 50px;
				width: 100%;
				span {
					display:block;
					position: relative;
					top: 0 !important;
					text-transform: none;
					font-size: 12px;
					color: #b2b2b2;
				}
				&:before {
					opacity: .2;
				}
			}
		}
	}
	.pg-btn-holder {
		padding: 5px 0;

		@media (min-width: 600px)  {
			max-width: 244px;
			max-height: 156px;
			padding: 8px;
			float: left;
		}
		@media (max-width: 599px) {
			.pg-button .pg-icon .maintenance {
				position: absolute;
				width: 100%;
				height: 90%;
				margin-top: 5px;
				left:0;
				top: 0;
				padding: 4px;
				p {
					top:20px !important;
				}
			}
		}
		@media (min-width: 1024px) and (min-width: 1044px)  {
			max-height: 140px;
			padding-top: 0;
			padding-bottom: 0;
			float: none;
		}
	}

	.tw {
		.pg-btn-holder {
			margin: 0 auto;
			float: none;
			width: 100%;
		}
	}
</style>



// WEBPACK FOOTER //
// src/components/common/pg-button.vue